"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var antd_1 = require("antd");
var AppLogo_1 = require("./AppLogo");
var UiStateController_1 = require("../../shared/UiStateController");
var cbkeys_1 = require("../shared/includes/cbkeys");
var FontAwesome_1 = require("../../shared/components/icons/FontAwesome");
var react_custom_scrollbars_1 = require("react-custom-scrollbars");
var VersionInfo_1 = require("./VersionInfo");
var UILanguage_1 = require("../UILanguage");
var UIDocLayout = /** @class */ (function (_super) {
    __extends(UIDocLayout, _super);
    function UIDocLayout(props) {
        var _this = _super.call(this, props) || this;
        _this.MENU_WIDTH = 220;
        return _this;
    }
    UIDocLayout.prototype.componentWillMount = function () {
        var _this = this;
        this.SID = this.props.controller.Subscribe("*", function (id, data) {
            var group = _this.props.controller.GetGroupByRoute(data.activeRoute);
            var item = _this.props.controller.GetItemByRoute(data.activeRoute);
            var item_id = "";
            var group_id = "";
            var group_title = "";
            var item_title = "";
            if (item) {
                item_id = item.itemId;
                item_title = item.title;
            }
            if (group) {
                group_id = group.groupId;
                group_title = group.title;
            }
            var _extPath = data.extBreadCrumbPath;
            _this.setState({
                groups: data.groups,
                activeRoute: data.activeRoute,
                activeQuery: data.activeQuery,
                activeDocument: data.activeDocument,
                logged: data.logged,
                groupTitle: group_title,
                itemTitle: item_title,
                activeGroupId: group_id,
                activeItemId: item_id,
                extBreadCrumbPath: _extPath,
                org_id: data.org_id
            });
        });
        this.setState({
            groups: this.props.controller.DATA.groups,
            activeRoute: this.props.controller.DATA.activeRoute,
            activeQuery: this.props.controller.DATA.activeQuery,
            activeDocument: this.props.controller.DATA.activeDocument,
            logged: this.props.controller.DATA.logged,
            groupTitle: "",
            itemTitle: "",
            activeGroupId: "",
            activeItemId: "",
            extBreadCrumbPath: [],
            lang: UILanguage_1.IUILanguageFactory.getLangInstance(this.props.controller.getLang()),
            org_id: this.props.controller.getOrgId()
        });
    };
    UIDocLayout.prototype.componentWillUnmount = function () {
        this.props.controller.UnSubscribe(this.SID);
    };
    UIDocLayout.prototype.menuClick = function (e) {
        if (e) {
            if (e.key) {
                if (this.props.onMenuClick) {
                    this.props.onMenuClick(e.key);
                }
            }
        }
    };
    UIDocLayout.prototype.getMenuGroupItems = function (group) {
        var _ret = [];
        for (var j = 0; j < group.items.length; j++) {
            _ret.push(React.createElement(antd_1.Menu.Item, { key: "" + group.items[j].itemId },
                this.getMenuItemIcon(group.items[j]),
                group.items[j].title));
        }
        return _ret;
    };
    UIDocLayout.prototype.getMenuItemIcon = function (item) {
        if (item.iconKind === "normal") {
            return (React.createElement(FontAwesome_1.FA, { left: true, icon: item.icon }));
        }
        else {
            console.log('bold');
            return (React.createElement(FontAwesome_1.FA, { left: true, icon: item.icon, kind: "bold" }));
        }
    };
    UIDocLayout.prototype.getMenuRootItems = function () {
        var _ret = [];
        for (var i = 0; i < this.state.groups.length; i++) {
            if (this.state.groups[i].groupType === UiStateController_1.UIGroupType.ugtRoot) {
                for (var j = 0; j < this.state.groups[i].items.length; j++) {
                    _ret.push(React.createElement(antd_1.Menu.Item, { key: "" + this.state.groups[i].items[j].itemId },
                        this.getMenuItemIcon(this.state.groups[i].items[j]),
                        this.state.groups[i].items[j].title));
                }
            }
        }
        return _ret;
    };
    UIDocLayout.prototype.getMenuGroups = function () {
        var _ret = [];
        for (var i = 0; i < this.state.groups.length; i++) {
            if (this.state.groups[i].groupType === UiStateController_1.UIGroupType.ugtGroup) {
                var _item = (React.createElement(antd_1.Menu.SubMenu, { key: this.state.groups[i].groupId, title: React.createElement("span", null,
                        React.createElement(FontAwesome_1.FA, { left: true, icon: "" + this.state.groups[i].icon }),
                        this.state.groups[i].title) }, this.getMenuGroupItems(this.state.groups[i])));
                _ret.push(_item);
            }
        }
        return _ret;
    };
    UIDocLayout.prototype.onMenuItemClick = function (e) {
        var item = this.props.controller.GetItemByItemId(e.key);
        if (item.itemType === UiStateController_1.UIItemType.uitCallBack) {
            if (item.callback) {
                item.callback(e.key);
            }
        }
        if (item.itemType === UiStateController_1.UIItemType.uitRoute) {
            this.props.controller.NavigateItem(item);
        }
    };
    UIDocLayout.prototype.getMenuSection = function () {
        return (React.createElement(antd_1.Menu, { theme: "dark", mode: "inline", selectedKeys: [this.state.activeItemId], defaultOpenKeys: [this.state.activeGroupId], style: { borderRight: 0, overflowX: "hidden", overflowY: "auto" }, onClick: this.onMenuItemClick.bind(this) },
            this.getMenuGroups(),
            this.getMenuRootItems()));
    };
    UIDocLayout.prototype.buildExtBreadCrumbs = function () {
        var _ret = [];
        for (var i = 0; i < this.state.extBreadCrumbPath.length; i++) {
            _ret.push(React.createElement(antd_1.Breadcrumb.Item, { key: this.state.extBreadCrumbPath[i] }, this.state.extBreadCrumbPath[i]));
        }
        return _ret;
    };
    UIDocLayout.prototype.getRenderObject = function () {
        if (this.state.logged) {
            //{this.state.lang.layout.menu.account.profile}
            //{this.state.lang.layout.menu.account.exit}
            return (React.createElement(antd_1.Layout, { style: { width: "100vw", height: "100vh", overflow: "hidden" } },
                React.createElement(antd_1.Layout.Header, { className: "header", style: { padding: 0 } },
                    React.createElement("div", { style: { display: "flex", width: "100vw", flexDirection: "row", justifyContent: "space-between", alignItems: "center", flexWrap: "nowrap" } },
                        React.createElement("div", { className: "logo", style: { justifySelf: "left", alignSelf: "flex-start", display: "flex", justifyContent: "center", alignItems: "center", width: this.MENU_WIDTH + "px", height: "64px" } },
                            React.createElement(AppLogo_1.default, null)),
                        React.createElement(VersionInfo_1.default, { orgId: this.state.org_id, state: this.props.controller }),
                        React.createElement(antd_1.Menu, { theme: "dark", mode: "horizontal", style: { lineHeight: '64px', minWidth: "180px" }, selectedKeys: [], onClick: this.menuClick.bind(this) },
                            React.createElement(antd_1.Menu.SubMenu, { style: { minWidth: "170px" }, key: 2, title: React.createElement("span", null,
                                    React.createElement(FontAwesome_1.FA, { left: true, icon: "user-circle" }),
                                    " [ ",
                                    this.props.controller.GetUserLogin(),
                                    " ]") },
                                React.createElement(antd_1.Menu.Item, { key: cbkeys_1.CallBackKeys.main_menu_key_logout },
                                    React.createElement(FontAwesome_1.FA, { left: true, icon: "power-off" }),
                                    "\u0412\u044B\u0445\u043E\u0434"))))),
                React.createElement(antd_1.Layout, null,
                    React.createElement(antd_1.Layout.Sider, { width: this.MENU_WIDTH, style: { background: '#001529', overflowX: "hidden", overflowY: "hidden" } },
                        React.createElement(react_custom_scrollbars_1.default, { style: { width: "100%", height: "100%" }, autoHide: true }, this.getMenuSection())),
                    React.createElement(antd_1.Layout, { style: { background: '#fff', padding: '0 12px 12px' } },
                        React.createElement(antd_1.Breadcrumb, { style: { background: '#fff', margin: '4px 0' } },
                            React.createElement(antd_1.Breadcrumb.Item, null, this.state.groupTitle),
                            React.createElement(antd_1.Breadcrumb.Item, null, this.state.itemTitle),
                            this.buildExtBreadCrumbs()),
                        React.createElement(antd_1.Layout.Content, { style: { background: '#fff', padding: 12, margin: 0, minHeight: 280 } }, this.state.activeDocument)))));
        }
        else {
            return this.state.activeDocument;
        }
    };
    UIDocLayout.prototype.render = function () {
        return (this.getRenderObject());
    };
    return UIDocLayout;
}(React.Component));
exports.default = UIDocLayout;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/UIDocLayout.tsx
// module id = 1723
// module chunks = 0